// components/Login.tsx
import React from 'react';
import { Form, Input,  Row, Col, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import styles from './Login.module.scss';
import Button from '../../components/Button';
import { useSecureService } from '../../store/service';
import { useAtom } from 'jotai';
import { messageAtom, loadingAtom } from '../../store/atoms';

interface LoginFormValues {
  email: string;
  password: string;
  remember: boolean;
}

const Login: React.FC = () => {
  const { doLogin } = useSecureService();
  const [, setMessage] = useAtom(messageAtom);
  const [loading, setLoading] = useAtom(loadingAtom);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values: LoginFormValues) => {
    setLoading(true);
    try {
      const response = await doLogin(values.email, values.password);

      if (response.success) {
        setMessage({ message: 'Login successful', type: 'success' });
        window.location.href = '/';  // navigate yerine window.location.href kullanıyoruz
        return;
      }

      messageApi.error({
        content: response.message || 'Invalid email or password',
        duration: 3
      });
    } catch (error) {
      messageApi.error({
        content: 'An error occurred during login',
        duration: 3
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      {contextHolder}
      <div className={styles.ellipseContainer}>
        <div className={styles.ellipse1}></div>
        <div className={styles.ellipse2}></div>
        <div className={styles.ellipse3}></div>
      </div>
      <div className={styles.loginContainer}>
        <Row className={styles.contentWrapper}>
          <Col md={12} span={24} className={styles.leftSide} />
          <Col md={12} span={24} className={styles.rightSide}>
            <div className={styles.formContainer}>
              <h2>Welcome Back!</h2>
              <p className={styles.subtitle}>Sign in to your account to continue.</p>

              <Form<LoginFormValues>
                name="login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                layout="vertical"
                className={styles.form}
              >
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Please input your email!' },
                    { type: 'email', message: 'Please enter a valid email!' }
                  ]}
                >
                  <Input 
                    size="small" 
                    prefix={<UserOutlined />} 
                    placeholder="Email" 
                    className={styles.input}
                    disabled={loading}
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password 
                    size="small" 
                    prefix={<LockOutlined />} 
                    placeholder="Password" 
                    className={styles.input}
                    disabled={loading}
                  />
                </Form.Item>

                <div className={styles.formFooter}>
                  {/* <Form.Item name="remember" valuePropName="checked">
                    <Checkbox className={styles.rememberMe} disabled={loading}>Keep me logged in</Checkbox>
                  </Form.Item> */}
                  <a href="#" className={styles.forgotPassword}>Forgot Password?</a>
                </div>

                <Form.Item>
                  <Button width="full" htmlType="submit" loading={loading}>
                    Log in
                  </Button>
                </Form.Item>
              </Form>

             {/*  <p className={styles.dontHaveAccount}>
                Don't have an account?
              </p> */}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Login;
